import React, { FC, useRef, useState } from 'react';

//devextreem
import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import moment from 'moment';

import { DateRangeBox } from 'devextreme-react';

import { comingNomenclatureReport } from '../../../../../../bus/report/actions';
import { ComingNomenclatureReportType } from '../../../../../../bus/report/types';
import { AppGroup, AppRow } from '../../../../../../components/appComponents';
import ModalFooter from '../../../../../../components/appModalFooter';
import { useDispatchPromise } from '../../../../../../hooks/useDispatchPromise';

type CreateEditModalProps = {
  visible: boolean;
  onClose: () => void;
};

const initialForm: ComingNomenclatureReportType = {
  dateBegin: moment(new Date()).format('YYYY-MM-DD'),
  dateEnd: moment(new Date()).format('YYYY-MM-DD'),
};

const CreateEditModal: FC<CreateEditModalProps> = ({ onClose, visible }) => {
  const dispatch = useDispatchPromise();

  let createFactoryGroupValidationRef = useRef<ValidationGroup>(null);

  const [dateBegin, setDateBegin] = useState(moment().startOf('month').format('YYYY-MM-DD'));
  const [dateEnd, setDateEnd] = useState(moment(new Date()).format('YYYY-MM-DD'));
  const [loading, setLoading] = useState(false);

  const onHidden = () => {
    setDateBegin(initialForm.dateBegin);
    setDateEnd(initialForm.dateEnd);
    createFactoryGroupValidationRef.current?.instance.reset();
  };

  const handleChangeDate = (dateRange: Array<string | Date | number>) => {
    dateRange[0] && setDateBegin(dateRange[0].toString());
    dateRange[1] && setDateEnd(dateRange[1].toString());
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();

    if (createFactoryGroupValidationRef.current?.instance.validate().isValid) {
      setLoading(true);
      await dispatch(
        comingNomenclatureReport.async({
          dateBegin,
          dateEnd,
        }),
      );
      setLoading(false);
      onClose();
    }
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={onClose}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Отчет"
        width={500}
        onHidden={onHidden}
        height="auto"
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit}>
              <ValidationGroup ref={createFactoryGroupValidationRef}>
                <Form id="test-facrory" formData={{ dateBegin, dateEnd }}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppRow>
                      <AppGroup col={12}>
                        <DateRangeBox
                          value={[dateBegin, dateEnd]}
                          onValueChanged={(e) => handleChangeDate(e.value)}
                          dateSerializationFormat="yyyy-MM-dd"
                          stylingMode="underlined"
                          useMaskBehavior
                          className="mr-2"
                        >
                          <Validator>
                            <RequiredRule message="Заполните поле дата" />
                          </Validator>
                        </DateRangeBox>
                      </AppGroup>
                    </AppRow>
                  </Item>
                </Form>
                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={onClose}
                  textConfirm="Скачать"
                  disabledSubmit={loading}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default CreateEditModal;
